module.exports = __webpack_public_path__ + "static/media/mail.8b1d4bba.png";